export default function QuickView() {
  const socialLinks = [
    {
      name: '인스타그램',
      icon: 'https://public.readdy.ai/ai/img_res/279d5f501db0745dec4c5b1f8c1c54a7.jpg',
      url: 'https://www.instagram.com/thinkgym2024/',
      description: '일상과 프로그램 소식'
    },
    {
      name: '네이버 블로그',
      icon: 'https://readdy.ai/api/search-image?query=Naver%20blog%20official%20logo%20icon%20in%20green%20color%20on%20white%20background%2C%20simple%20clean%20modern%20design%2C%20square%20format%2C%20high%20quality%20Korean%20brand%20identity&width=200&height=200&seq=social-naver-001&orientation=squarish',
      url: 'https://blog.naver.com/think_gym',
      description: '교육 정보와 후기'
    },
    {
      name: '유튜브',
      icon: 'https://readdy.ai/api/search-image?query=YouTube%20official%20logo%20icon%20in%20red%20color%20on%20white%20background%2C%20simple%20clean%20modern%20design%2C%20square%20format%2C%20high%20quality%20brand%20identity&width=200&height=200&seq=social-youtube-001&orientation=squarish',
      url: 'https://youtube.com/channel/UCyXrpEpVecUyqGNsJN9V0dA?si=XSgJouQ9UOm-V4fi',
      description: '영상으로 보는 씽크짐'
    }
  ];

  return (
    <section className="py-12 md:py-20 lg:py-24 bg-gradient-to-b from-white to-orange-50/30">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-3 md:mb-4">
            씽크짐 교육 아카이브
          </h2>
          <p className="text-base md:text-lg text-gray-600 max-w-2xl mx-auto px-4">
            씽크짐의 교육 철학과 수업 현장을 다양한 콘텐츠로 만나보세요
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {socialLinks.map((social, index) => (
            <a
              key={index}
              href={social.url}
              target="_blank"
              rel="noopener noreferrer"
              className="group bg-white rounded-2xl p-6 md:p-8 shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="flex flex-col items-center text-center space-y-4 md:space-y-6">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl overflow-hidden shadow-md group-hover:shadow-xl transition-shadow duration-300">
                  <img
                    src={social.icon}
                    alt={social.name}
                    className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-300"
                  />
                </div>
                
                <div>
                  <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-2 group-hover:text-orange-500 transition-colors">
                    {social.name}
                  </h3>
                  <p className="text-sm text-gray-600">
                    {social.description}
                  </p>
                </div>

                <div className="flex items-center gap-2 text-orange-500 font-medium group-hover:gap-3 transition-all">
                  <span className="text-sm whitespace-nowrap">바로가기</span>
                  <i className="ri-arrow-right-line text-lg"></i>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
